<template>
  <div class="flex items-center justify-between border rounded mb-2 p-2 text-primary">
    <div>
      <p class="font-semibold">{{ association.target.title }}</p>

      <div class="text-sm text-secondary">
        <BookingElementsServicePrice
          :price-label="association.target.priceLabel"
          :price-from="association.target.priceFrom"
          :price-has-additional-taxes="association.target.priceHasAdditionalTaxes"
          :has-discount="association.discountAmount > 0"
          :discounted-price="discountedPrice"
        />
      </div>
    </div>

    <div>
      <UButton v-if="!isSelected" @click="onAddService">
        Add
      </UButton>
      <UButton v-else @click="onRemoveService">
        Remove
      </UButton>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ServiceAssociation, Employee, Service } from '@@/types/api';

const props = defineProps({
  association: {
    type: Object as PropType<ServiceAssociation>,
    required: true
  },
  selectedEmployees: {
    type: Array as PropType<Employee[]>,
    required: true
  }
})

const { $site, $store } = useNuxtApp()

const selectedServices = computed(() => {
  return $store.getters['booking/serviceSelections']
})

const isSelected = computed(() => {
  return selectedServices.value[props.association.target.id] && selectedServices.value[props.association.target.id]?.selected
})

const discountedPrice = computed(() => {
  const discountAmount = props.association.discountAmount
  const discountType = props.association.discountType

  const calc = (amount) => {
    const symbol = $site.location.currencySymbol
    return symbol + parseFloat(amount || 0).toFixed(2)
  }

  if (discountType === 0) {
    let amount = props.association.target.price - discountAmount
    return calc(amount)
  }

  if (discountType === 1) {
    let amount = props.association.target.price - (props.association.target.price * discountAmount / 100)
    return calc(amount)
  }

  return ''
})

const onAddService = async () => {
  const target = props.association.target
  const services = $store.getters['location/getAllServices']
  const serviceEmployees = services.find((service: Service) => target.id === service.id)?.employeeServices
  const selectedEmployeeIds = Object.values(selectedServices.value)
    .map((service: any) => service.selectedEmployee?.id)
    .filter(Boolean)

  // Find the first employeeService whose employee IS in the selectedEmployees list
  const employeeService = serviceEmployees?.find((es: any) => selectedEmployeeIds.includes(es.employee?.id))

  if (employeeService) {
    await $store.dispatch('booking/setServiceSelected', { service: target, employee: employeeService.employee, selected: true })
  } else {
    await $store.dispatch('booking/setServiceSelected', { service: target, selected: true })
  }
}

const onRemoveService = async () => {
  const target = props.association.target
  await $store.dispatch('booking/setServiceSelected', { service: target, selected: false })
}
</script>